module.exports = __webpack_public_path__ + "static/media/Barcelona_1-0243.8a48bd6e.jpg";